import React, {Component} from 'react';
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import {SubmissionError} from 'redux-form';
import ForgotForm from './ForgotForm';
import * as session from '../../../services/session';
import ApiConfig from '../../../constants/ApiConfig';
import {toast} from "react-toastify";

class ForgotPassword extends Component {


    constructor(props) {

        super(props);

        this.state = {
            data: {}
        };

        this.submit = this.submit.bind(this);

    }

    submit(values) {

        const {history} = this.props;



        return memberService.forgotPassword(values)

            .then((data) => {
                toast.success('Un noueau mot de passe a été envoyé');

                history.push('/login')

            })
            .catch((exception) => {

                throw new SubmissionError({_error : exception['error']});

            });


    }

    render() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="8">
                            <CardGroup className="mb-4">
                                <Card className="p-4">
                                    <CardBody>
                                        <h1 style={{ color : '#4F4F4F'}}>Reinitialisation mot de passe</h1>
                                        <p className="text-muted">Merci de saisir votre email</p>

                                        <ForgotForm onSubmit={this.submit} history={this.props.history}/>

                                    </CardBody>
                                </Card>

                            </CardGroup>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/ForgotPassword.js